import React, { useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  PageHeader,
  CustomPanel,
  Loading,
  CustomCheckbox,
  Btn,
  CustomDropdown,
  CustomDataTableHeader,
  DateTime,
  CustomMultiSelect,
  CustomTabView,
} from '../../../../components'
import { TabPanel } from 'primereact/tabview'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as TransferHttp from '../../../../services/api/https/deliveries/delivery-transfer.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import { errorHandler } from '../../../../services/util/error.service'
import { Fieldset } from 'primereact/fieldset'
import { convertToFormatedDateString } from '../../../../services/util/date.service'
import { postDeliveryCiclesConsolidado } from '../../../../services/api/https/deliveries/delivery.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'

function RecebimentoTransferencia({ selectedTp, history, dispatch }) {
  const [isLoading, toggleLoading] = useState(true)
  const [transferencias, setTransferencias] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [datasOperacao, setDatasOperacao] = useState([])
  const [transferenciasOriginal, setTransferenciasOriginal] = useState([])
  const [transferenciasBase, setTransferenciasBase] = useState([])
  const [transferenciasOptions, setTransferenciasOptions] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const [, setFilters] = useState({
    empresaIndex: '',
    dataOperacaoIndex: [],
    transferencia: [],
  })

  const [ufOptions, setUfOptions] = useState([])
  const [selectedUfs, setSelectedUfs] = useState([])
  const [citiesOptions, setCitiesOptions] = useState([])
  const [selectedCities, setSelectedCities] = useState([])
  const [bairrosOptions, setBairrosOptions] = useState([])
  const [selectedBairros, setSelectedBairros] = useState([])

  useEffect(() => {
    _fetchTransferencias()
  }, [selectedTp])

  const filtrarTransferencias = (base, f) => {
    return base.filter(t => {
      const filtraEmpresa =
        f.empresaIndex !== '' ? t.company === empresas[f.empresaIndex].label : true
      const filtraData = f.dataOperacaoIndex.length
        ? f.dataOperacaoIndex.includes(t.data_operacao)
        : true
      const filtraTransferencia = f.transferencia.length
        ? f.transferencia.includes(t.transfer_id)
        : true
      return filtraEmpresa && filtraData && filtraTransferencia
    })
  }

  const aplicarFiltros = f => {
    const filtrado = filtrarTransferencias(transferenciasOriginal, f)
    setTransferenciasBase([...filtrado])
  }

  const onCheckBoxClicked = (transferencia, checked) => {
    transferencia.selected = checked
    setTransferencias([...transferencias])
  }

  const onSelecionarTodos = checked => {
    const alvo =
      activeTab === 0
        ? transferencias.filter(t => t.status_id === 3)
        : transferencias.filter(t => [1, 16].includes(t.status_id))
    alvo.forEach(t => (t.selected = checked))
    setTransferencias([...transferencias])
  }

  const onBtnVoltar = () => {
    history.goBack()
  }

  const onFilterChange = (empresaIndex, dataOperacaoIndex, transferencia) => {
    const novoFiltro = { empresaIndex, dataOperacaoIndex, transferencia }
    setFilters(novoFiltro)
    aplicarFiltros(novoFiltro)
  }

  const onReceber = async () => {
    try {
      const selecionadas = transferenciasOriginal.filter(f => f.selected && f.status_id === 3)
      const steps_ids = selecionadas.map(s => s.delivery_step_id)
      const fecthedTransferencia = await TransferHttp.receiveDeliveriesFromTransfer(steps_ids)
      refreshUI(fecthedTransferencia)
      dispatch(showMessageBox('Transferências recebidas com sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onGerarCrossRecebimento = async () => {
    try {
      const selecionadas = transferencias.filter(f => f.selected)
      if (!selecionadas.length) throw new Error('Nenhuma transferência selecionada')
      const companies = new Set(selecionadas.map(s => s.company))
      if (companies.size > 1) throw new Error('Selecione transferências de uma única empresa')
      const { id: user_id } = getUsuarioInfo()

      await postDeliveryCiclesConsolidado({
        deliveries_ids: selecionadas.map(s => s.delivery_id),
        company_id: selecionadas[0].company_id,
        tp_id: selectedTp,
        cycleInfo: {
          name:
            'Cross Recebimento – Transferência - ' +
            convertToFormatedDateString(new Date().toISOString()),
          type: 'cross-recebimento',
        },
        user_id,
      })

      dispatch(showMessageBox('Cross-Recebimento gerado com sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const _fetchTransferencias = async () => {
    try {
      const fecthedTransferencia = await TransferHttp.getDeliveriesFromTransfer(selectedTp)
      refreshUI(fecthedTransferencia)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      toggleLoading(false)
    }
  }

  const _buildEmpresas = fecthedTransferencia => {
    let builtEmpresas = []
    if (fecthedTransferencia.length > 0) {
      const empresasName = new Set(fecthedTransferencia.map(t => t.company))
      builtEmpresas = Array.from(empresasName).map((e, index) => ({ label: e, value: index }))
    }
    return builtEmpresas
  }

  const _buildDatasOperacao = fecthedTransferencia => {
    let builtDatasOperacao = []
    if (fecthedTransferencia.length > 0) {
      const datasOperacao = new Set(fecthedTransferencia.map(t => t.data_operacao))
      builtDatasOperacao = Array.from(datasOperacao).map(d => ({
        label: convertToFormatedDateString(d),
        value: d,
      }))
    }
    return builtDatasOperacao
  }

  const refreshUI = fecthedTransferencia => {
    const builtEmpresas = _buildEmpresas(fecthedTransferencia)
    setTransferenciasOriginal([...fecthedTransferencia])
    setEmpresas([...builtEmpresas])
    setDatasOperacao([..._buildDatasOperacao(fecthedTransferencia)])
    const transferenciasOptionsIds = Array.from(
      new Set(fecthedTransferencia.map(t => t.transfer_id)),
    )
    setTransferenciasOptions(
      transferenciasOptionsIds.map(t => {
        const item = fecthedTransferencia.find(f => f.transfer_id === t)
        return { label: item.transfer_name, value: item.transfer_id }
      }),
    )
    setFilters({ empresaIndex: '', dataOperacaoIndex: [], transferencia: [] })
    setTransferenciasBase([...fecthedTransferencia])

    const ufs = [...new Set(fecthedTransferencia.map(t => t.uf).filter(Boolean))].sort()
    setUfOptions(ufs.map(u => ({ label: u, value: u })))

    setSelectedUfs([])
    setSelectedCities([])
    setSelectedBairros([])
    setCitiesOptions([])
    setBairrosOptions([])
  }

  // Filtro de Localização (igual 3.4): calcula Cities/Bairros dinamicamente e aplica no resultado final
  useEffect(() => {
    // ponto de partida: resultado dos filtros originais
    let filtradasSemBairro = transferenciasBase

    // filtra por UF
    if (selectedUfs.length) {
      filtradasSemBairro = filtradasSemBairro.filter(t => selectedUfs.includes(t.uf))
    }

    // recalcula options de Cidades com base nas UFs selecionadas
    const novasCidades = [...new Set(filtradasSemBairro.map(t => t.city).filter(Boolean))]
      .sort()
      .map(c => ({ label: c, value: c }))
    setCitiesOptions(novasCidades)

    // filtra por Cidades
    if (selectedCities.length) {
      filtradasSemBairro = filtradasSemBairro.filter(t => selectedCities.includes(t.city))
    }

    // recalcula options de Bairros com base em UF/Cidade
    const novosBairros = [...new Set(filtradasSemBairro.map(t => t.district).filter(Boolean))]
      .sort()
      .map(b => ({ label: b, value: b }))
    setBairrosOptions(novosBairros)

    // filtra por Bairros
    let finalFiltradas = filtradasSemBairro
    if (selectedBairros.length) {
      finalFiltradas = finalFiltradas.filter(t => selectedBairros.includes(t.district))
    }

    // Resultado final exibido nas tabelas/abas
    setTransferencias([...finalFiltradas])
  }, [transferenciasBase, selectedUfs, selectedCities, selectedBairros])

  const transferenciasPendentes = transferencias.filter(
    t => t.status_id === 3 && t.delivery_step_id === t.event_delivery_step_id,
  )
  const transferenciasTransferidas = transferencias.filter(
    t => [1, 16].includes(t.status_id) || t.delivery_step_id !== t.event_delivery_step_id,
  )

  return (
    <div>
      <PageHeader>3.3 - Recebimento de Transferência de Entrega</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={onBtnVoltar}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <>
              <FormFilter
                onSelecionarTodos={onSelecionarTodos}
                empresas={empresas}
                datasOperacao={datasOperacao}
                onFilterChange={onFilterChange}
                onReceber={onReceber}
                onGerarCrossRecebimento={onGerarCrossRecebimento}
                transferenciasOptions={transferenciasOptions}
                disabledReceber={activeTab === 1}
              />
              <Fieldset
                legend="Filtro"
                toggleable
                collapsed={true}
                className="p-col-12"
                style={{ marginTop: 20 }}
              >
                <div style={{ display: 'flex', gap: 16 }}>
                  <div className="p-col-2" style={{ minWidth: 200 }}>
                    <CustomMultiSelect
                      marginTop={10}
                      label="Estados"
                      options={ufOptions}
                      value={selectedUfs}
                      onChange={setSelectedUfs}
                    />
                  </div>
                  <div className="p-col-2" style={{ minWidth: 200 }}>
                    <CustomMultiSelect
                      marginTop={10}
                      label="Cidades"
                      options={citiesOptions}
                      value={selectedCities}
                      onChange={setSelectedCities}
                    />
                  </div>
                  <div className="p-col-2" style={{ minWidth: 200 }}>
                    <CustomMultiSelect
                      marginTop={10}
                      label="Bairros"
                      options={bairrosOptions}
                      value={selectedBairros}
                      onChange={setSelectedBairros}
                    />
                  </div>
                </div>
              </Fieldset>
              <CustomTabView activeIndex={activeTab} onTabChange={setActiveTab}>
                <TabPanel header="Aguardando Transferência">
                  <DataTableTransferencias
                    transferencias={transferenciasPendentes}
                    onCheckBoxClicked={onCheckBoxClicked}
                  />
                </TabPanel>
                <TabPanel header="Transferido">
                  <DataTableTransferencias
                    transferencias={transferenciasTransferidas}
                    onCheckBoxClicked={onCheckBoxClicked}
                  />
                </TabPanel>
              </CustomTabView>
            </>
          )}
        </CustomPanel>
      </div>
    </div>
  )
}

function FormFilter({
  onSelecionarTodos,
  empresas,
  transferenciasOptions,
  onFilterChange,
  onReceber,
  datasOperacao,
  onGerarCrossRecebimento,
  disabledReceber,
}) {
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [selectedEmpresa, setSelectedEmpresa] = useState('')
  const [selectedDatasOperacao, setSelectedDatasOperacao] = useState([])
  const [selectedTransferencia, setSelectedTransferencia] = useState([])

  const onCheckBoxClicked = checked => {
    setSelecionarTodos(checked)
    onSelecionarTodos(checked)
  }

  const onFilterSelected = (empresa, dataOperacao, transferencia) => {
    setSelectedEmpresa(empresa)
    setSelectedDatasOperacao(dataOperacao)
    setSelectedTransferencia(transferencia)
    onFilterChange(empresa, dataOperacao, transferencia)
  }

  const limpar = () => {
    setSelectedEmpresa('')
    setSelectedDatasOperacao([])
    setSelectedTransferencia([])
    onFilterChange('', [], [])
  }

  return (
    <Fieldset legend="Fitro">
      <div className="p-grid">
        <div className="p-col-2" style={{ paddingTop: 30 }}>
          <CustomCheckbox checked={selecionarTodos} onChange={onCheckBoxClicked}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div className="p-col-2">
          <CustomMultiSelect
            marginTop={0}
            value={selectedDatasOperacao}
            options={datasOperacao}
            label="Data de Operação"
            onChange={value => onFilterSelected(selectedEmpresa, value, selectedTransferencia)}
          />
        </div>
        <div className="p-col-2">
          <CustomDropdown
            marginTop={0}
            value={selectedEmpresa}
            options={empresas}
            label="Empresas"
            onChange={value =>
              onFilterSelected(value, selectedDatasOperacao, selectedTransferencia)
            }
          />
        </div>
        <div className="p-col-2">
          <CustomMultiSelect
            marginTop={0}
            value={selectedTransferencia}
            options={transferenciasOptions}
            label="Transferências"
            onChange={value => onFilterSelected(selectedEmpresa, selectedDatasOperacao, value)}
          />
        </div>
        <div className="p-col-1" style={{ paddingTop: 23 }}>
          <Btn onClick={onReceber} disabled={disabledReceber}>
            Receber
          </Btn>
        </div>
        <div className="p-col-1" style={{ paddingTop: 23 }}>
          <Btn onClick={limpar}>Limpar</Btn>
        </div>
        <div className="p-col-2" style={{ paddingTop: 23 }}>
          <Btn onClick={onGerarCrossRecebimento}>Gerar Cross-Recebimento</Btn>
        </div>
      </div>
    </Fieldset>
  )
}

function DataTableTransferencias({ transferencias, onCheckBoxClicked }) {
  const [globalFilter, setGlobalFilter] = useState('')
  return (
    <div style={{ marginTop: 20 }}>
      <DataTable
        value={transferencias}
        emptyMessage="Não existem Entregas pendentes para recebimento"
        globalFilter={globalFilter}
        header={<CustomDataTableHeader onChange={setGlobalFilter} />}
        paginator
        rows={10}
      >
        <Column
          style={tableCellCentered(80)}
          body={transferencia => (
            <CustomCheckbox
              checked={transferencia.selected}
              onChange={value => onCheckBoxClicked(transferencia, value)}
            />
          )}
        />
        <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
        <Column field="razao_social" header="Razão Social" />
        <Column
          field="data_operacao"
          header="Data Operação"
          body={item => <DateTime>{item.data_operacao}</DateTime>}
        />
        <Column field="city" header="Cidade" />
        <Column field="district" header="Bairro" />
        <Column field="tp_name_from" header="Origem" style={tableCellCentered(150)} />
        <Column field="company" header="Empresa" style={tableCellCentered(150)} />
        <Column field="qte_sku" header="Qte Sku" style={tableCellCentered(80)} />
        <Column field="weight" header="Peso" style={tableCellCentered(80)} />
      </DataTable>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RecebimentoTransferencia))
